import { useContext, useEffect, useState } from "react";
import { getOrder } from "../../services/OrderServices";
import { Alert, Button, Modal, Table } from "react-bootstrap";
import { Link, useNavigate, useParams } from "react-router-dom";
import { GlobalFunctionsContext } from "../../services/GlobalFunctionsContext";
import { ArrowLeft } from "react-bootstrap-icons";
import { AuthContext } from "../../services/AuthContext";
import { addToCart } from "../../services/CartServices";

export default function UserProfileOrderDetais() {
  const { id } = useParams()
  const { user, updateCart, setNotAddedCart } = useContext(AuthContext);
  const { formatCurrency, formatNumber } = useContext(GlobalFunctionsContext)
  const [order, setOrder] = useState(null);
  const { location } = window;
  const navigate = useNavigate()
  const [showModal, setShowModal] = useState(false)
  const [orderId, setOrderid] = useState(0)

  useEffect(()=>{
    let params = {
      id: id,
    }
    if (location.hash.split('/')[2] === 'detalle_pedido_finalizado'){
      params = {
        ...params,
        state: 3
      }
    }

    getOrder(params)
      .then((data) => {
        setOrder(data);
      })
      .catch(err => console.log(err))
  },[id, location.hash]);

  const confirmAddCart = (id) => {
    setOrderid(id)
    setShowModal(true)
  }

  const handleAddToCart = () => {
      const params = {
        id: orderId,
        state: location.hash.split('/')[2] === 'detalle_pedido_finalizado' ? 3 : 1
      }
      setShowModal(false)
      addToCart(params)
      .then((rsp) => {
        updateCart(rsp.data)
        setNotAddedCart(rsp.notAdded.length>0)
        navigate('/carrito')
      })
      .catch((err) => console.log('err',err))
    }

  return (
    <>
      {order &&
       <>
        <div>
          <p className="text-right"><Link to={'/perfil-usuario/pedidos'}>
          <ArrowLeft />
          Volver a Pedidos</Link></p>
          <div>Fecha: <b>{order.date}</b></div>
          <div>Nro Pedido: <b>{formatNumber(order.id)}</b></div>
          <div>Estado: <b>{order.state}</b></div>
          <div>Cliente: <b>{order.client}</b></div>
          <div>Dirección de Envío: <b>{order.shippingAddress}</b></div>
          {order.shipping && <div>Transporte: <b>{order.shipping}</b></div>}
          <div>Observaciones: <b style={{ whiteSpace: 'pre-line' }} dangerouslySetInnerHTML={{ __html: order.observaciones }}></b></div>
          {user.isSeller ?
            <>
              {order.seller && order.seller !== ""
                ? <div className="message-seller">Pedido creado por el vendedor en nombre del cliente</div>
                : null
              }
              {order.client_discount > 0 
                ? order.discount_visible 
                  ?<div className="message-seller">El cliente contaba con un descuento visible de {order.client_discount}% cuando se realizo el pedido</div>
                  :<div className="message-seller">El cliente contaba con un descuento NO visible de {order.client_discount}% cuando se realizo el pedido</div>
                : null
              }
            </>
            : order.discount_visible && order.client_discount > 0 
                ? <div className="message-seller">Contabas con un descuento de {order.client_discount}% cuando se realizaste el pedido</div>
                : null
          }
        </div>
        <div className="btn-content right">
        <Button class="btn btn-third small" onClick={()=>{confirmAddCart(id)}}>Volver a Pedir</Button></div>
        {order.items.length > 0 && 
          <Table responsive className="mt-5">
            <thead>
              <tr>
                <th>Producto</th>
                <th>Variación</th>
                <th>Cantidad</th>
                <th>Precio</th>
                <th>Dto</th>
                <th>Iva</th>
                <th>Subtotal</th>
              </tr>
            </thead>
            <tbody>
              {order.items.map((it)=>{
                return (
                  <tr>
                    <td>{it.name}</td>
                    <td>{it.variation}</td>
                    <td><span className="float-end">{it.amount}</span></td>
                    <td><span className="float-end">$ {formatCurrency(it.price)}</span></td>
                    <td><span className="float-end">$ {formatCurrency(it.price*(it.discount/100))}</span></td>
                    <td><span className="float-end"> {it.iva}%</span></td>
                    <td><span className="float-end">$ {formatCurrency(it.subtotal)}</span></td>
                  </tr>
                )
              })}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="6" className="text-end fw-bold">Subtotal</td>
                <td className="fw-bold"><span className="float-end">$ {formatCurrency(order.subtotal)}</span></td>
              </tr>
              <tr>
                {order.discount_visible && order.client_discount > 0
                  ? <>
                      <td colSpan="6" className="text-end fw-bold">Descuento Cliente {order.client_discount}%</td>
                      <td className="fw-bold"><span className="float-end">$ {formatCurrency(order.subtotal*(order.client_discount/100))}</span></td>
                    </>
                  : null
                }
              </tr>
              <tr>
                <td colSpan="6" className="text-end fw-bold">Iva Acumulado</td>
                <td className="fw-bold"><span className="float-end">$ {formatCurrency(order.iva_acumulado)}</span></td>
              </tr>
              <tr>
                <td colSpan="6" className="text-end fw-bold">Total</td>
                <td className="fw-bold"><span className="float-end">$ {formatCurrency(order.total)}</span></td>
              </tr>
            </tfoot>
          </Table>
        }
      </>
      }
      <Modal show={showModal}>
          <Alert.Heading>Repetir Pedido</Alert.Heading>
          <p>Se creara un carrito nuevo con los productos del pedido seleccionado.
          Tenga en cuanta que el carrito actual se le eliminara por completo.</p>
          <hr />
          <div className="btn-content right">
            <Button onClick={() => handleAddToCart()} variant="primary" className="small">
              Aceptar
            </Button>
            <Button onClick={() => setShowModal(false)} variant="secondary" className="small">
              Cancelar
            </Button>
          </div>
        </Modal>
    </>
  )
}